import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { DatePicker } from '@material-ui/pickers'
import { filter, get } from 'lodash'

const CheckOutDatePicker = (props) => {
  const { notAvailablePeriods, minStay, maxStay } = props
  const { errors, watch } = useFormContext()
  const values = watch()
  const { t } = useTranslation()
  return (
    <DatePicker
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
      inputVariant="outlined"
      fullWidth
      error={errors.end_date}
      maxDate={getMaxDate(values, notAvailablePeriods, maxStay)}
      format="DD-MM-yyyy"
      minDate={moment(values.start_date).add(minStay, 'months').toISOString(true)}
      label={t('booking.checkIn.dateCheckOut.placeholder')}
      name="end_date"
    />
  )
}

function getMaxDate(values, notAvailablePeriods, maxStay) {
  let dates = []
  if (values.start_date) {
    if (notAvailablePeriods) {
      const startD = get(
        filter(notAvailablePeriods, (period) => moment(period.endDate).isAfter(values.start_date)),
        '0.startDate',
      )
      if (typeof startD !== 'undefined') {
        dates.push(startD)
      }
    }

    if (maxStay) {
      dates.push(moment(values.start_date).add(maxStay, 'months'))
    }
  }

  return dates.length > 0 ? moment.min(dates).toISOString(true) : undefined
}

export default CheckOutDatePicker
